export default {
    signup: "Sign up",
    soon: "Coming soon",
    more: "Learn more",
    active: "Active slide:",
    jump: "Jump to slide",
}